/* eslint-disable */
/**
 * @author Leonel Martinez 
 * @module settings
 * @fileoverview `Vuex settings module` that comes back from the settings API.
 */
import { inquiryService } from "@/services";
import { rootAction } from "../index";
import { MESSAGES, router, ROUTES } from "@/utils";
import Vue from 'vue';

const storage = JSON.parse(
  localStorage.getItem(process.env.VUE_APP_LOCALSTORAGE_DATA)
);

const mapAnswersToSpanish = {
  Yes: "Si",
  No: "No",
  "Don't know": "No lo sé",
  "None of the above": "Ninguna de las anteriores"
};

const mapQuestionsToSpanish = {
  "Select from the following choices": "Elige una opción"
}

export const parts = {
  namespaced: true,
  state: {
    groupsBasket: storage?.groupsBasket || [],
    partsBasket: storage?.partsBasket || [],
    partListBasket: storage?.partListBasket || [],
    selected_count: 0,
    selected_c2c: null,
    mfgBasket: [],
    mfgsBasket: [],
    pagination: storage?.parts?.pagination || [],
    grouped_by_description: storage?.parts?.grouped_by_description || [],
    groups: storage?.parts?.groups || [],
    uniquepartsDescriptions: storage?.uniquepartsDescriptions || [],
    showPricing: true,
    group_list: {}, // Do not store the parts here, just use it for mapping the indexes
    // in what group and index you can find the part, the state doesn't allow to mantain the same
    // referece for the parts in the grouped_manufactureres and the group_list when initializing from the storage, so, just
    // use it for indexes, even if the parts values are empty values, already tried with a constant outside this object to no avail
    specificConditionsQuestions: storage?.specificConditionsQuestions || [],
    new_unanswered_questions_indices: [],
    specificConditionsAnswers: [],
    request: null,
    powerboxPart: null,
    c2c: '',
    currentC2C: null,
    size: 25,
    page: 1,
    toggleSelectedIcon: false,
  },
  getters: {
    catalog: (state, getters, rootState) => rootState.catalog.categories,
    categories: (state, getters) =>
      getters.catalog.map(item => ({ id: item.id, name: item.name})),
    getCategoryItems: (state, getters) => id =>
      [getters.catalog.find(cat => cat.id === id)]
        .map(group => group.items.map(x => ({ id: x.id, name: x.name })))
        .reduce((acc, cur) => acc.concat(cur), []),
    mfgItems: (state, getters) =>
      getters.manufacturer.map(item => (item)),
    onlyGroups: (state, getters) =>
      getters.catalog.map(cat => cat.items).reduce((acc, cur) => acc.concat(cur), []),
    /**
     * @param {group}
     * @description Creates a new array with the Group Items
     * @readonly
     */
    getGroupItems: (state, getters) => group =>
      [getters.onlyGroups.find(g => g.id == group.id)].map(g => ({
        group,
        items: g.items.map(part => ({
          group,
          id: part.id,
          name: part.name
        }))
      })),
    getPartTypesItems: (state, getters) =>
      getters.onlyGroups.map(group => group.items).reduce((acc, cur) => acc.concat(cur), []),
    totalSelectedCount: state => state.groupsBasket.length + state.partsBasket.length,
    totalGroupBasketCount: state => state.groupsBasket.length,
    totalPartBasketCount: state => state.partsBasket.length,
    uniquepartsDescriptionsCount: state => state.uniquepartsDescriptions.length,
    toggleSelectedIconBoolean: state => state.toggleSelectedIcon,
    /**
     * 
     * @param {specificConditionsQuestions} state 
     * @description 
     */
    specificConditionsQuestions: state => state.specificConditionsQuestions,
    provider: (state, getters, rootState) => rootState.settings.skin.provider,
    currentC2C: (state, getters) => state.currentC2C,
    urlC2C: (getters) => getters.currentC2C?.data.url,
    /**
     * @description A group can be either selected directly or indirectly if its children are selected. We need to care about if the user selects a part type else the catalog service will respond with a 500 Server Internal Error.
    */
    groupsForInquiry: state => {
      // Get the groups from selected parts
      const groupFromParts = state.partsBasket.map(part => ({
        id: part.group.id,
        name: part.group.name
      }));
      // Merge both group lists
      const merged = [...state.groupsBasket, ...groupFromParts];
      // Remove duplicated groups
      const uniqueGroups = merged
        .map(e => e["id"])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter(e => merged[e])
        .map(e => merged[e]);
      return uniqueGroups;
    },
    partTypesForInquiry: state =>
      state.partsBasket.map(part => ({id: part.id, name: part.name, groupId: part?.group ? part?.group?.id : part?.groupId})),
    mfgForInquiry: state => [...state.mfgBasket],
    groupBasket: state => [...state.groupsBasket],
    /**
     * @description Transforms an inquiry request from the Catalog parts lookup
     */
    basicCatalogRequest: (state, getters, rootState, rootGetters) => {
      // Set the properties of the request if data is present/
      let request = {};
      request["vehicle"] = rootGetters["vehicle/vehicleForInquiry"];
      if (getters.groupBasket.length)
        request["partGroups"] = getters.groupBasket;
      if (state.partsBasket.length)
        request["partTypes"] = getters.partTypesForInquiry;
      if (state.specificConditionsQuestions.length)
        request["specificConditions"] = state.specificConditionsQuestions;

      return request;
    },
    /**
     * @description Transforms an inquiry request from the Powerbox
     * @param {object} part
     */
    powerboxRequest: (state, getters, rootState, rootGetters) => part => {
      // Construct the request based on present properties
     // Construct the request based on present properties
     const parts = part
     let request = {};
     request["vehicle"] = rootGetters["vehicle/vehicleForInquiry"];
     if (state.specificConditionsQuestions.length)
       request["specificConditions"] = state.specificConditionsQuestions;
     if (part.type === "partTypes") {
       request["partGroups"] = [{ id: part.value.groupId, name: part.value.groupName }];
       request["partTypes"] = [{ id: part.value.id, name: part.value.name, groupId: part.value.groupId }];
     } else if (part.type === "partGroups") {
       request["partGroups"] = [{ id: part.value.id, name: part.value.name }];
     } else {
       return false;
     }
     return request;
    }

  },
  actions: {
    /**
     * @description If an inquiry returns back with SCQ, and they are selected then add the user answers.
     * @param {Array} answers 
     * @see SCQ.vue
     */
    SET_SPECIFIC_ANSWERS({ commit }, answers) {
      commit("SET_SPECIFIC_ANSWERS", answers);
    },
    /**
     * @description Display the SCQ questions to the user.
     * @param {Array} questions 
     */
    SET_SPECIFIC_CONDITION_QUESTIONS({ commit, dispatch }, questions) {
      commit("SET_SPECIFIC_CONDITION_QUESTIONS", questions);
      dispatch("modals/TOGGLE_MODAL_STATE", { name: "SCQ", value: true }, rootAction);
    },
    CONCAT_NEW_SPECIFIC_CONDITION_QUESTIONS({ commit, dispatch }, questions) {
      commit("CONCAT_NEW_SPECIFIC_CONDITION_QUESTIONS", questions);
      dispatch("modals/TOGGLE_MODAL_STATE", { name: "SCQ", value: true }, rootAction);
    },
    ANSWER_SPECIFIC_CONDITION_QUESTION({ commit, dispatch }, { question, index, answer }) {
      commit("ANSWER_SPECIFIC_CONDITION_QUESTION", { question, index, answer });
    },
    REMOVE_SPECIFIC_CONDITION_QUESTIONS({ commit }) {
      commit("REMOVE_SPECIFIC_CONDITION_QUESTIONS");
    },
    /**
     * @description Looks in the catalog database.
     * The vehicle must me always present.Same case for partGroups even though we are looking for a part type.
     * @param {object} params
     * @example { vehicle, partGorups, partTypes }
     */
    INQUIRY: async ({ dispatch, commit, rootState }, { page, size, group_by, request }) => {
      dispatch("spinner/TOGGLE_SPINNER", { active: true }, rootAction); /* START SPINNER */

      commit("SET_PARTS", { groups: [], groups_by_description: [] });

      const response = await inquiryService.inquiry(page, size, group_by, request);

      if (response.statusText != "OK")             /* ERROR */
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.ERROR.INQUIRY, rootAction);

      else {
        // Can return: No content | Specific Conditions | Parts
        const inquiry = response.data;

        if (!Object.entries(inquiry).length)       /* NO CONTENT */
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.NO_PARTS_FOUND, rootAction);

        else if (inquiry.specificConditionsResult) /* SPECIFIC CONDITIONS */
          // Open modal to display conditions
          dispatch("CONCAT_NEW_SPECIFIC_CONDITION_QUESTIONS", inquiry.specificConditionsResult);

        else if (!inquiry.partsResult?.length)     /* NO PARTS */
          //(Do not join NO CONTENT with NO PARTS in one If, first ask for Specific Conditions)
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.NO_PARTS_FOUND, rootAction);

        else {                                     /* PART LIST */
          const pagination_inquiry = inquiry;
          commit("SET_PAGINATION_INQUIRY", pagination_inquiry)
          const groups = inquiry.partsResult;
          const groups_by_description = await dispatch("GET_PARTS_GROUPED_BY_DESCRIPTION", groups)
          commit("SET_PARTS", { groups, groups_by_description });
          dispatch("powerbox/RESET_VEHICLES_PARTS", null, rootAction)

          if (router.app.$route.name != 'parts-result')
            router.push({ name: 'parts-result', params: { provider: rootState.settings.skin.provider } });
        }
        dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction); /* END SPINNER */
      }
    },
    SET_PARTS_FOR_INTERCHANGE({ commit }, { groups, groups_by_description }) {
      commit("SET_PARTS", { groups, groups_by_description })
    },
    /**
    * @description Loads a Cover-to-cover landing page based on the requested URL.
    * @param {object} request Url
    */
    SET_C2C: async ({ commit }, part) => commit("SET_C2C", { part }),
    GET_C2C: async ({ commit, dispatch }, part) => {
      const response = await inquiryService.getC2C(part.catalogOrderNumber, part.partNum);


      if (response.statusText != "OK") {
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.ERROR.C2C, { root: true });
        return;
      }
      
      commit("SET_C2C", { part, c2c: response.data.url });
    },
    /**
     * @description Toggles the basket on the catalog lookup
     * @see DefaultCatalog.vue
     * @param {string} model Could be `partGroupBasket` or `partTypesBasket`
     * @param {object} item { id, name }
     */
    TOGGLE_PART_SELECTION({ commit }, part) {
      commit("TOGGLE_PART_SELECTION", part);
    },
    /**
     * @description Cleans away the selected parts on the basket for a later request.
     */
    RESET_PARTS_LOOKUP({ commit }) {
      commit("RESET_PARTS_LOOKUP");
    },
    RESET_PARTS({ commit }) {
      commit("RESET_PARTS");
    },
    /**
     * @description Cleans away the selected parts on the basket for a later request.
     */
    RESET_PARTS_TYPES({ commit }) {
      commit("RESET_PARTS_TYPES");
    },
    /**
     * @description Cleans away the selected parts on the basket for a later request.
     */
    RESET_MFG_LOOKUP({ commit }) {
      commit("RESET_MFG_LOOKUP");
    },
    /**
    * @description Cleans away the selected parts on the basket for a later request.
    */
    RESET_ALL_SPECIFIC_CONDITION({ commit }) {
      commit("RESET_ALL_SPECIFIC_CONDITION");
    },
    /**
     * @description Cleans away the answered specific conditions
     */
    RESET_SPECIFIC_ANSWERS({ commit }) {
      commit("RESET_SPECIFIC_ANSWERS");
    },
    /**
     * @description Cleans away the answered specific conditions
     */
    RESET_PART_LIST({ commit }) {
      commit("RESET_PART_LIST");
    },
    SELECT_PART({ commit }, part) {
      commit("SELECT_PART", item);
    },
    TOGGLE_SELECTION_GROUP: ({ commit }, { model, group }) => commit("TOGGLE_SELECTION_GROUP", { model, group }),

    TOGGLE_SELECTION_C2C({ commit }, { model, part }) {
      commit("TOGGLE_SELECTION_C2C", { model, part });
    },
    TOGGLE_SELECTION_SINGLE_PARTS_TYPES({ commit }, { model, part, type}) {
      commit("TOGGLE_SELECTION_SINGLE_PARTS_TYPES", { model, part, type});
    },
    TOGGLE_SELECTION_ALL_PARTS_TYPES({ commit }, { model, parts, uniquepartDescriptions, type }) {
      commit("TOGGLE_SELECTION_ALL_PARTS_TYPES", { model, parts, uniquepartDescriptions, type });
    },
    TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS({ commit }, { model, groups }) {
      commit("TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS", { model, groups });
    },
    ACTIVE_PART_TYPES_ICON({ commit }) {
      commit("ACTIVE_PART_TYPES_ICON");
    },
    GET_THUMBNAIL({ commit }, { part, index, signal }) {
      const stoHandler = setTimeout(async () => {
        const response = await inquiryService.getThumbnail(part.catalogOrderNumber, part.partNum, signal);
        const thumbnail = (response?.statusText == "OK" && response.data?.thumbnail) || false;

        commit("SET_THUMBNAIL", { part, thumbnail });
      }, index * 1000)

      return stoHandler;
    },
    GET_PARTS_GROUPED_BY_DESCRIPTION: ({ }, groups) => {
      const description_indexes = {};

      return groups.reduce((parts_grouped_by_description, manufacturer) => {
        manufacturer.parts.forEach(part => {
          part.selected = false;
          part.c2c = '';
          part.manufacturer = manufacturer.name;
          part.thumbnailURL = `/images/loading_thumbnail.gif`;
          part.info = part.info?.replace(/\n/g, " ");

          if (!(part.description in description_indexes)) {
            description_indexes[part.description] = parts_grouped_by_description.length;
            parts_grouped_by_description.push({ name: part.description, parts: [] });
          }

          parts_grouped_by_description[description_indexes[part.description]].parts.push(part);
        });

        return parts_grouped_by_description;
      }, []);
    },
    GET_UNIQUE_PART_DESCRIPTIONS: async  ({commit, dispatch}, {requestArray, group}) => {
      dispatch("spinner/TOGGLE_SPINNER", { active: true }, rootAction); /* START SPINNER */
      const response = await inquiryService.uniqueDescriptions(requestArray)
      if(response?.data.status !== undefined) {
        if(response?.data.status === 500 ){
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.ERROR.UNIQUE_DESCRIPTION_ERROR, rootAction);
        } 
        else if(response?.data.status === 404) {
          dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.NO_PARTS_FOUND, rootAction);
        }
      }
      const items = response.data.items
      const arrayUnique = {
        group: {
          id: group.id,
          name: group.name
        },
        items: items !== undefined ? items : [{groupNum: group.id, id: 1, name: "NO HAY TIPOS DE PARTES DISPONIBLES"}]
      }
        commit("SET_UNIQUE_PART_DESCRIPTIONS_ARRAY", {arrayUnique, group})
      dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction); /* END SPINNER */
      return response

    },
    SET_UNIQUE_PART_DESCRIPTIONS_ARRAY({commit}, {arrayUnique, group}){
      commit("SET_UNIQUE_PART_DESCRIPTIONS_ARRAY", {arrayUnique, group})
    },
    RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY({commit}){
      commit("RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY")
    },
  },
  mutations: {
    SET_SPECIFIC_CONDITION_QUESTIONS(state, questions) {
      state.specificConditionsQuestions = questions;
      //add forEach 
      //hacer un ciclo de si ya existe la pregunta
    },
    CONCAT_NEW_SPECIFIC_CONDITION_QUESTIONS(state, new_questions) {
      new_questions.forEach(question => {
        question.selectedAnswerCode = '?';
        question.answers.forEach(answer => answer.answer = mapAnswersToSpanish[answer.answer] || answer.answer);
        question.question = mapQuestionsToSpanish[question.question] || question.question;
      });
      state.specificConditionsQuestions = state.specificConditionsQuestions.concat(new_questions);
    },
    ANSWER_SPECIFIC_CONDITION_QUESTION(state, { question, index, answer }) {
      Vue.set(state.specificConditionsQuestions[index], 'selectedAnswerCode', answer);
    },
    REMOVE_SPECIFIC_CONDITION_QUESTIONS(state) {
      state.specificConditionsQuestions = [];
    },
    RESET_SPECIFIC_ANSWERS(state) {
      state.specificConditionsAnswers = [];
    },
    SET_SPECIFIC_ANSWERS(state, payload) {
      state.specificConditionsAnswers = payload;
    },
    TOGGLE_SELECTION_GROUP(state, { model, group }) {
      const index = state[model].findIndex(i => i.id === group.id);
      index === -1 ? state[model].push(group) : state[model].splice(index, 1);
    },

    // Part parameter is optional, if not provided it will use the indexes to find the part
    TOGGLE_PART_SELECTION(state, part) {
      const index = state.partListBasket.findIndex(i => i === part);
      index === -1 ? state.partListBasket.push(part) : state.partListBasket.splice(index, 1);
    },
    TOGGLE_SELECTION_SINGLE_PARTS_TYPES(state, { model, part, type }) {
      if(type === 'normal'){
        const index = state[model].findIndex(i => i.id === part.id);
        index === -1 ? state[model].push(part) : state[model].splice(index, 1);
      } else if( type === 'unique') {        
        const index = state[model].findIndex(i => i.id === parseInt(part.id));
        const partTypeConvert = {
            groupId: parseInt(part.groupId),
            id: parseInt(part.id),
            name: part.name
        }

        index === -1 ? state[model].push(partTypeConvert) : state[model].splice(index, 1);
      }
    },
    TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS(state, { model, groups}) {

      const partTypes = state.uniquepartsDescriptions.find(i => i.group.id === groups.id)

      partTypes.items.forEach(part => {
        const index = state[model].findIndex(i => i.id === parseInt(part.id));
        index !== -1 ? state[model].splice(index, 1) : true
      })
      const index_unique = state.uniquepartsDescriptions.findIndex(i => i.group.id === parseInt(partTypes.group.id))
      index_unique !== -1 ? state.uniquepartsDescriptions.splice(index_unique, 1) : true
    },
    TOGGLE_SELECTION_ALL_PARTS_TYPES(state, { model, uniquepartDescriptions, type}) {
        //partTypes 
        const partTypes = uniquepartDescriptions

        if(partTypes[0].name !== 'NO HAY TIPOS DE PARTES DISPONIBLES'){
          partTypes.forEach(part => {
            const group_Id = parseInt(part.groupNum);
            const id = parseInt(part.id);
            const name = part.name;
            const partTypesUnique = {
              groupId: group_Id,
              id: id,
              name: name
            }
            if(type === 1) {
                  const index = state[model].findIndex(i => i.id === partTypesUnique.id);
                  index === -1 ? state[model].push(partTypesUnique) : true
                state.toggleSelectedIcon = true
            } 
            else if(type === 2) {
              const index = state[model].findIndex(i => i.id === partTypesUnique.id);
              index === -1 ? state[model].push(partTypesUnique) : true
            } else if(type === 3) {
              const index = state[model].findIndex(i => i.id === partTypesUnique.id);
              index === -1 ? state[model].push(partTypesUnique) : state[model].splice(index, 1) 
            }
          })
        }
    },
    RESET_PARTS_LOOKUP(state) {
      state.groupsBasket = [];
      state.partsBasket = [];
      state.uniquepartsDescriptions = [];
      state.uniqueNotFoundpartsDescriptions = [];
    },
    SET_THUMBNAIL: ({ }, { part, thumbnail }) => part.thumbnailURL = thumbnail && `data:image/jpg;base64,${thumbnail}`,
    SET_PARTS(state, { groups, groups_by_description }) {
      state.groups = groups;
      state.grouped_by_description = groups_by_description;
    },
    SET_PAGINATION_INQUIRY(state, pagination_inquiry) {
      state.pagination = pagination_inquiry
    },
    RESET_PARTS(state) {
      state.groups = [];
      state.groups_by_description = [];
    },
    RESET_MFG_LOOKUP(state) {
      state.mfgBasket = [];
    },
    SET_C2C(state, { part, c2c }) {
      if (c2c)
        part.c2c = c2c;

      state.selected_c2c = part;
    },
    RESET_PARTS_TYPES(state) {
      state.partsBasket = [];
      state.toggleSelectedIcon = false;
      state.uniquepartsDescriptions = [];
      state.uniqueNotFoundpartsDescriptions = [];
    },
    RESET_PART_LIST(state) {
      state.partListBasket = [];
    },
    RESET_ALL_SPECIFIC_CONDITION(state) {
      state.specificConditionsQuestions = [];
      state.new_unanswered_questions_indices = [];
      state.specificConditionsAnswers = [];
    },
    ACTIVE_PART_TYPES_ICON(state){
      if(state.toggleSelectedIcon === false ){
        state.toggleSelectedIcon = true
      } else {
        state.toggleSelectedIcon = false
      }
    },
    SET_UNIQUE_PART_DESCRIPTIONS_ARRAY(state, {arrayUnique, group}) {
      const index = state.uniquepartsDescriptions.findIndex(i => i.id === group.id);
      index === -1 
      ? state.uniquepartsDescriptions.push(arrayUnique) 
      : state.uniquepartsDescriptions.splice(index, 1);
    },
    RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY(state) {
      state.uniquepartsDescriptions = [];
    },
  }
};
